import JamEventOnboarding from '@/src/components/game/JamEventOnboarding/JamEventOnboarding';
import React from 'react';

export const JamEventOnboardingPage: React.FC = () => {
  return <JamEventOnboarding />;
};
